var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "box",
      staticStyle: { padding: "20px" },
      attrs: { id: "new-contract" }
    },
    [
      _c("vue-loading", {
        attrs: {
          active: _vm.isSaving,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.isSaving = $event
          }
        }
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", appear: "" } }, [
        _c("div", [
          _c("h4", [_vm._v("Add Contract")]),
          _vm._v(" "),
          _c(
            "form",
            {
              attrs: { id: "accounts" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.addContract($event)
                }
              }
            },
            [
              _c("div", { staticClass: "form-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newContract,
                      expression: "newContract"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: {
                    "max-width": "300px",
                    "margin-bottom": "10px"
                  },
                  attrs: {
                    type: "text",
                    id: "contractname",
                    placeholder: "contract name",
                    required: ""
                  },
                  domProps: { value: _vm.newContract },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newContract = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("button", { staticClass: "btn btn-primary" }, [
                  _vm._v("Add Contract")
                ])
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64390038", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64390038","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ContractNew.vue
// module id = null
// module chunks = 